import { ifoodConstants } from '@constants/ifood';

const initialState = {
    data: [],
    loading: true,
    error: '',
    orders: [],
};

export function ifood(state = initialState, action) {
    switch (action.type) {
        case ifoodConstants.IFOOD_MERCHANTS_REQUEST:
            return { ...state, loading: true, error: '' };
        case ifoodConstants.IFOOD_MERCHANTS_SUCCESS:
            return { ...state, loading: false, data: action.data, error: '' };
        case ifoodConstants.IFOOD_MERCHANTS_ERROR:
            return { ...state, error: action.message };
        case ifoodConstants.IFOOD_MERCHANTS_RESET:
            return { ...state, data: [] };
        case ifoodConstants.IFOOD_ORDERS_REQUEST:
            return { ...state, loading: true };
        case ifoodConstants.IFOOD_ORDERS_SUCCESS:
            return { ...state, orders: action.data || [], loading: false };

        default:
            return state;
    }
}
